import { useEffect, useState } from 'react';
import
{
  StyledTable,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
} from './SubscriptionsList.styles';
import { subscriptionColumns } from '../../../options/tableColumns';
import CustomTableWrapper from '../CustomTableWrapper/CustomTableWrapper';
import CustomTableHead from '../CustomTableHead/CustomTableHead';
import SectionSpinner from '../../Loading/SectionSpinner/SectionSpinner';
// import CustomToggle from '../../Inputs/CustomToggle/CustomToggle';

// Helpers
import { getComparator, stableSort, handleRequestSort } from '../../../utils/tableSortHelpers/tableSortHelpers';
import { formatStandardDateString } from '../../../utils/helpers/formatDateString';
import LinkButton from '../../Buttons/LinkButton/LinkButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import { getCustomerPortalRedirect } from '../../../api';
// import SectionContainer from '../../Containers/SectionContainer/SectionContainer';
// import InvoicesList from '../InvoicesList/InvoicesList';
import { getCustomerPortalUrl, handleCustomerPortalRedirect } from '../../../utils/helpers/billingHelper';

import { routes } from '../../../options/routes';

const redirectToLicencePage = async () =>
{
  window.location.href = routes.indexLicences;
}
const SubscriptionsList = ({
  subscriptions,
  onAutoRenewChange,
  autoRenewLoading,
  onSubscriptionChangeClick
}) =>
{
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [redirectLoading, setRedirectLoading] = useState(false);
  const [billingUrl, setBillingUrl] = useState(null);

  useEffect(async () =>
  {
    if (!billingUrl)
    {
      let url = await getCustomerPortalUrl();
      if (url)
      {
        setBillingUrl(url);
      }
    }
  });

  return (
    <>
      <CustomTableWrapper
        noResultsText={false && (!subscriptions || subscriptions.length === 0) && 'No Subscriptions to display'}
      >
        <StyledTable>
          <CustomTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={(e, id) => handleRequestSort(e, id, orderBy, order, setOrder, setOrderBy)}
            columnHeadings={subscriptionColumns}
          />
          <StyledTableBody>
            {
              subscriptions.length === 0 &&
              <StyledTableRow
                key="0"
              >
                <StyledTableCell
                  align="left">
                  INDEX TRIAL&nbsp;&nbsp;
                  <LinkButton
                    text={'Upgrade'}
                    onClick={redirectToLicencePage}
                    disabled={false}
                  />
                </StyledTableCell>
                <StyledTableCell
                  align="center">
                  --
                </StyledTableCell>
                <StyledTableCell
                  align="center">
                  --
                </StyledTableCell>
                <StyledTableCell
                  align="center">
                  --
                </StyledTableCell>
              </StyledTableRow>
            }
            {
              subscriptions.length > 0 &&
              stableSort(subscriptions, getComparator(order, orderBy))
                .map(({ id, name, changeTo, frequency, nextAmount, expires, autoRenew }, idx) => (
                  <StyledTableRow
                    key={id}
                  >
                    <StyledTableCell
                      align={subscriptionColumns[0].align}>
                      {name}
                    </StyledTableCell>
                    <StyledTableCell
                      align={subscriptionColumns[1].align}>
                      {frequency}
                    </StyledTableCell>
                    <StyledTableCell

                      align={subscriptionColumns[2].align}>
                      {nextAmount}
                    </StyledTableCell>
                    <StyledTableCell
                      align={subscriptionColumns[3].align}>
                      {formatStandardDateString(expires)}
                    </StyledTableCell>
                    {billingUrl ?
                      <StyledTableCell
                        align={subscriptionColumns[4].align}>
                        {redirectLoading ?
                          <SectionSpinner />
                          :
                          <DeleteOutlineIcon onClick={() => { handleCustomerPortalRedirect(setRedirectLoading, billingUrl) }} />
                        }
                      </StyledTableCell>
                      :
                      <StyledTableCell></StyledTableCell>
                    }
                  </StyledTableRow>
                ))
            }
          </StyledTableBody>
        </StyledTable>
      </CustomTableWrapper >
    </>
  );
};

export default SubscriptionsList;
